export default __webpack_public_path__ + "static/media/VEUE_Stacked Logo_RGB_Rose@2x.2ae40ad8.png";